import React, { useEffect, useRef } from 'react';
import style from '../../../assets/styles/modalStyle.module.css';
interface ModalData {
  title: string;
  description: string;
  cancelButton: string;
  saveButton: string;
}
interface MediumModalProps {
  forwardButton: () => void;
  modalData: ModalData;
  modalMedium: boolean;
  closeModalMedium: () => void;
}
const MediumModal: React.FC<MediumModalProps> = ({ forwardButton, modalData, modalMedium, closeModalMedium }) => {
  // ___________ forward button calling on save and make action accordingly ___________
  const ForwardButton = () => {
    forwardButton();
    modalData.title !== text && closeModalMedium();
  };
  const text = 'Changing the passage will modify the answers.';
  const text2 = 'Are you sure, Do you want to cancel Question Creation?';
  const text3 = 'Requires a Review';
  const text4 = 'Are you sure, Do you want to change your Question Type?';

  // outside clickable close modal
  const modalRef = useRef<HTMLDivElement>(null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleOverlayClick = (event: any) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      closeModalMedium();
    }
  };

  useEffect(() => {
    // Attach the event listener when the component mounts
    document.addEventListener('mousedown', handleOverlayClick);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('mousedown', handleOverlayClick);
    };
  }, [handleOverlayClick]);

  let modalClassName = '';
  if (modalData.title === text || modalData.title === text2 || modalData.title === text3) {
    modalClassName = 'highlightModel';
  }
  if (modalData.title === text4) {
    modalClassName = style.backModal;
  }
  return (
    <>
      {modalMedium ? (
        <div className={`${style.mediumModal} ${modalClassName}`}>
          <div className={style.center_div} ref={modalRef}>
            <h3>{modalData.title}</h3>
            <p>{modalData.description}</p>

            {/* SAVE BUTTON AND CANCEL BUTTON  */}
            <div className={style.saveButton_questionCreation_Modal}>
              <button
                id=""
                className={` ${style.cancel} ${style.pointer}`}
                onClick={() => closeModalMedium()}
                style={{ border: 'none', background: 'none', padding: '0px' }}
              >
                {modalData.cancelButton}
              </button>
              <div>
                <button id="modelClick" className={style.blue_button} onClick={() => ForwardButton()}>
                  {' '}
                  {modalData.saveButton}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default MediumModal;
